import React from 'react';

import {
	makeStyles,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
	card: {
		borderTop: 'solid 1px #dfdfe6',
		borderBottom: 'solid 1px #dfdfe6',
		backgroundColor: '#fff',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginTop: 5,
		marginBottom: 5,
		padding:20,
		minHeight:100
	},
	imageReplace: {
		width: 55,
		height: 55,
		backgroundColor: '#30b0ff',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		color: 'white',
		fontSize: 18,
		fontWeight: 600,
		fontFamily: 'IBM Plex Sans',
		borderRadius: 44,
		marginRight:20
	},
	avatar: {
        width: 55,
        height: 55,
		border:'solid 1.8px #dfdfe6',
		marginRight:20
	},
	button: {
		border:'solid 1px #dfdfe6',
		backgroundColor:'#fff',
		fontFamily: 'IBM Plex Sans',
		fontSize:14,
		color:'#044ada',
		fontWeight:500,
		margin:5,
		width:'100%',
		textTransform:'none',
		'&:hover': {
			backgroundColor:'#edf4ff'
		}
	},
	textInfo: {
		color:'#5e6784',
		fontSize:14,
		margin:5
	},
	validadeInfo: {
		display:'flex',
		flexFlow:'column',
		alignItems:'center',
		margin:12
	}
}));

export default useStyles;